module.exports = __webpack_public_path__ + "img/dummy.b509e7b9.jpg";